import { render, staticRenderFns } from "./ReactionsBar.vue?vue&type=template&id=3aca8021&lang=pug&"
import script from "./ReactionsBar.vue?vue&type=script&lang=js&"
export * from "./ReactionsBar.vue?vue&type=script&lang=js&"
import style0 from "./ReactionsBar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports